import {
  EDIT_POSITION,
  EDIT_POSITION_CLEAN,
  EDIT_POSITION_SUCCESS,
  EDIT_POSITION_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  position: undefined,
}

const PositionEdit = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_POSITION:
      state = {
        ...state,
        loading: true,
      }
      break
    case EDIT_POSITION_SUCCESS:
      state = {
        ...state,
        loading: false,
        done: true,
        position: action.payload.position,
      }
      break
    case EDIT_POSITION_CLEAN:
      state = initialState
      break
    case EDIT_POSITION_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default PositionEdit
